export default __webpack_public_path__ + "static/media/add.a48e7ec6.jpg";